import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=fb1d34f2&scoped=true&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"
import style0 from "./addEvent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addEvent.vue?vue&type=style&index=1&id=fb1d34f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1d34f2",
  null
  
)

export default component.exports